<template>
  <div>
    <div class="xlg-section ti-page-start pt2 pb1 mx2">
      <div class="p1 pb2">
        <router-link :to="{name: 'connect-list'}" class="ti-link">🡸 Vendor Connect</router-link>
      </div>
      <div v-if="$store.state.refMap" class="flex">
        <PopupSelector label="Sector" headerClass="ti-tag-sector"
                    :listItems="$store.state.refMap.vertical_items"
                    :items="$store.state.refMap.verticals"
                    :filters="$store.state.verticals"
                    @itemClick="setVerticalItem"
                    :selected="compareVert"
                    class="col-6 md-col-4 pr2"
                    />
        <PopupSelector label="Technology" headerClass="ti-tag-technology"
                       :listItems="this.$store.getters.getTechKeys"
                       :items="$store.state.refMap.tech_areas"
                       :show="$store.state.refMap.connectTech"
                       :filters="$store.state.techs"
                       @itemClick="setTechItem"
                       :selected="compareTech"
                       class="col-6 md-col-4 pr2"/>
      </div>
      <table v-if="!loading" class="ti-tbl2 ti-tbl2-double"
             style="width:100%; table-layout:fixed">
        <thead>
          <tr class="ti-tbl-dark sticky-header">
            <th class="ti-tbl2-header" style="text-align:left; width:300px; font-size:20px">
              Criteria
            </th>
            <th v-for="(vendor, idx) in vendors" :key="vendor.id" class="ti-tbl2-header bold"
                style="border:1px solid #E5E5E5; background-color:white;">
              <a @click="rmVendor(idx, vendor.id)" class="btn-column-rm">Ⓧ</a>
                <img v-if="vendor.logo" :alt="vendor.name"
                     :src="vendor.logo" style="width:100px;height:auto; margin:3px;"/>
                <span v-else style="font-size:1.6rem;">{{vendor.name}}</span>
                <div class="mt2">
                  <router-link :to="{name: 'connect-detail',
                                    params: {id: vendor.id, slug:toSlug(vendor.name)}}"
                               class="ti-link ti-link-underline"
                               style="color:#0089c7; font-weight:normal;"
                               target="_blank">
                    All Capabilities
                  </router-link>
                  <button class="btn btn-primary ml3" @click="showEnquire(vendor)">
                    Enquire
                  </button>
                </div>
            </th>
          </tr>
        </thead>
        <tbody v-if="compareVert && compareTech">
          <tr v-for="cap in capsDef" :key="cap.id" class="ti-tbl2-row"
              :style="{ 'background-color': rowColorMap(cap.src) }">
            <td class="ti-tbl2-border-left ti-tbl2-border-right ti-tbl2-val"
                style="word-break:break-word">{{cap.label}}</td>
            <td v-for="vendor in vendors" :key="vendor.id"
                class="ti-tbl2-border-right">
              {{truncate(vendorCaps[vendor.id][cap.id], 300)}}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!compareVert || !compareTech" class="pt1">
        <p class="p1" v-if="!compareVert">Select a Sector.</p>
        <p class="p1" v-if="!compareTech">Select a Technology.</p>
      </div>
    </div>
    <EnquireModal v-if="showEnquireModal" @close="showEnquireModal=false"
                  :vendorId="vendorId" :vendorName="vendorName"
                  :enquirer="enquirer" :tech="compareTech" :vertical="compareVert"
                  >
    </EnquireModal>
  </div>
</template>

<script>
import axios from 'axios';

import EnquireModal from './EnquireModal.vue';
import PopupSelector from './PopupSelector.vue';

export default {
  name: 'ConnectCompare',
  components: { EnquireModal, PopupSelector },
  data() {
    return {
      loading: true, // first load of refMap
      showEnquireModal: false,

      vendorIds: null, // [id] taken from query parameters
      vendors: null, // [{id, name}]
      capsDef: null, // [{id, label, desc}]
      vendorCaps: null, // {vendor.id: value}}

      // data for enquire modal
      enquirer: null, // {email, name}
      vendorId: null,
      vendorName: null,
    };
  },

  computed: {
    compareTech() {
      const selected = this.$store.getters.getSelectedTech;
      if (selected.length === 1) {
        return selected[0];
      }
      return null;
    },
    compareVert() {
      const selected = this.$store.getters.getSelectedVert;
      if (selected.length === 1) {
        return selected[0];
      }
      return null;
    },
  },

  created() {
    this.vendorIds = this.$route.query.vendors;
    this.getData();
    this._rowColorMap = {
      sector: '#FDC83340', // yellow
      // base green for tech #94C23D
      IT: '#94C23D40',
      HC: '#94C23D40',
    };
  },

  methods: {
    truncate(str, size) {
      if (!str) {
        return '';
      }
      if (str.length < size) {
        return str;
      }
      return `${str.substring(0, size)} ...`;
    },

    rmVendor(index, vendorId) {
      const payload = { id: vendorId };
      this.$store.commit('toggleCompare', payload);
      const vendors = [];
      for (const vendor of this.vendors) {
        if (vendorId !== vendor.id) {
          vendors.push(vendor);
        }
      }
      this.vendors = vendors;
    },

    setTechItem(code) {
      const payload = { property: 'techs', id: code, val: true };
      this.$store.commit('resetFilter', payload);
      this.$nextTick().then(() => this.getData());
    },
    setVerticalItem(code) {
      const payload = { property: 'verticals', id: code, val: true };
      this.$store.commit('resetFilter', payload);
      this.$nextTick().then(() => this.getData());
    },

    _setVendors(src) {
      const vendors = [];
      for (const vendor of src) {
        if (!this.$store.state.compare[`${vendor.id}`]) {
          const payload = { id: vendor.id, val: vendor.name };
          this.$store.commit('toggleCompare', payload);
        }
        vendors.push(vendor);
      }
      this.vendors = vendors;
    },

    getData() {
      const params = {};
      if (this.$store.state.refMap === null) {
        // if page loaded from URL
        params.schema = '1';
      }
      const postData = { ids: this.vendorIds, tech: this.compareTech, vert: this.compareVert };
      axios.post('/api/connect/compare', postData, { params })
        .then((res) => {
          this.canAccess = res.data.canAccess;
          if (this.canAccess) {
            this._setVendors(res.data.vendors);
            this.capsDef = res.data.capsDef;
            this.vendorCaps = res.data.vendorCaps;
            this.enquirer = res.data.enquirer;
            if (this.$store.state.refMap === null) {
              this.$store.commit('initMaps', res.data.refMap);
            }
          }
          this.loading = false;
        });
    },

    showEnquire(vendor) {
      this.vendorId = vendor.id;
      this.vendorName = vendor.name;
      this.showEnquireModal = true;
    },

    rowColorMap(name) {
      return this._rowColorMap[name];
    },
  },
};
</script>

<style>
.btn-column-rm {
  color: red;
  text-align: right;
  position: absolute;
  top: 12px;
  right: 12px;
  font-size: 1.2rem;
  cursor: pointer;
}
</style>
